/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {HTTPValidationError, ProfilerMode, User} from '../models/index';
import {
  HTTPValidationErrorFromJSON,
  HTTPValidationErrorToJSON,
  ProfilerModeFromJSON,
  ProfilerModeToJSON,
  UserFromJSON,
  UserToJSON
} from '../models/index';

export interface UsersGetUserInfoRequest {
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

/**
 *
 */
export class UsersApi extends runtime.BaseAPI {
  /**
   * Get User Info
   */
  async usersGetUserInfoRaw(
    requestParameters: UsersGetUserInfoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<User>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/users/me`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
  }

  /**
   * Get User Info
   */
  async usersGetUserInfo(
    requestParameters: UsersGetUserInfoRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<User> {
    const response = await this.usersGetUserInfoRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
